/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AuditoriaAdminControllerExportarFunilCsvParams,
  AuditoriaAdminControllerListarFunilParams,
  AuditoriaAdminControllerListarParams,
  ErroResponse,
  ListaDeAutoresDoFunilResponse,
  PaginaDeAuditoriaResponse,
  PaginaDoFunilDiscussoesResponse,
  ResumoDoFunilResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAuditoriaAdminControllerListarUrl = (params?: AuditoriaAdminControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/auditoria?${stringifiedParams}` : `/v1/admin/auditoria`
}

/**
 * @summary Lista a trilha de auditoria, paginada e filtrável
 */
export const auditoriaAdminControllerListar = async (params?: AuditoriaAdminControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeAuditoriaResponse> => {

  return httpClient<PaginaDeAuditoriaResponse>(getAuditoriaAdminControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAuditoriaAdminControllerListarQueryKey = (params?: AuditoriaAdminControllerListarParams,) => {
    return [
    `/v1/admin/auditoria`, ...(params ? [params] : [])
    ] as const;
    }


export const getAuditoriaAdminControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof auditoriaAdminControllerListar>>, TError = ErroResponse>(params?: AuditoriaAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditoriaAdminControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditoriaAdminControllerListar>>> = ({ signal }) => auditoriaAdminControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditoriaAdminControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof auditoriaAdminControllerListar>>>
export type AuditoriaAdminControllerListarQueryError = ErroResponse


export function useAuditoriaAdminControllerListar<TData = Awaited<ReturnType<typeof auditoriaAdminControllerListar>>, TError = ErroResponse>(
 params: undefined |  AuditoriaAdminControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditoriaAdminControllerListar>>,
          TError,
          Awaited<ReturnType<typeof auditoriaAdminControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditoriaAdminControllerListar<TData = Awaited<ReturnType<typeof auditoriaAdminControllerListar>>, TError = ErroResponse>(
 params?: AuditoriaAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditoriaAdminControllerListar>>,
          TError,
          Awaited<ReturnType<typeof auditoriaAdminControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditoriaAdminControllerListar<TData = Awaited<ReturnType<typeof auditoriaAdminControllerListar>>, TError = ErroResponse>(
 params?: AuditoriaAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista a trilha de auditoria, paginada e filtrável
 */

export function useAuditoriaAdminControllerListar<TData = Awaited<ReturnType<typeof auditoriaAdminControllerListar>>, TError = ErroResponse>(
 params?: AuditoriaAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditoriaAdminControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAuditoriaAdminControllerResumoDoFunilUrl = () => {




  return `/v1/admin/auditoria/funil-discussoes/resumo`
}

/**
 * @summary Quantos rascunhos do wizard web (ainda ativos) estão parados em cada etapa agora
 */
export const auditoriaAdminControllerResumoDoFunil = async ( options?: Parameters<typeof httpClient>[1]): Promise<ResumoDoFunilResponse> => {

  return httpClient<ResumoDoFunilResponse>(getAuditoriaAdminControllerResumoDoFunilUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAuditoriaAdminControllerResumoDoFunilQueryKey = () => {
    return [
    `/v1/admin/auditoria/funil-discussoes/resumo`
    ] as const;
    }


export const getAuditoriaAdminControllerResumoDoFunilQueryOptions = <TData = Awaited<ReturnType<typeof auditoriaAdminControllerResumoDoFunil>>, TError = ErroResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerResumoDoFunil>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditoriaAdminControllerResumoDoFunilQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditoriaAdminControllerResumoDoFunil>>> = ({ signal }) => auditoriaAdminControllerResumoDoFunil({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerResumoDoFunil>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditoriaAdminControllerResumoDoFunilQueryResult = NonNullable<Awaited<ReturnType<typeof auditoriaAdminControllerResumoDoFunil>>>
export type AuditoriaAdminControllerResumoDoFunilQueryError = ErroResponse


export function useAuditoriaAdminControllerResumoDoFunil<TData = Awaited<ReturnType<typeof auditoriaAdminControllerResumoDoFunil>>, TError = ErroResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerResumoDoFunil>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditoriaAdminControllerResumoDoFunil>>,
          TError,
          Awaited<ReturnType<typeof auditoriaAdminControllerResumoDoFunil>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditoriaAdminControllerResumoDoFunil<TData = Awaited<ReturnType<typeof auditoriaAdminControllerResumoDoFunil>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerResumoDoFunil>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditoriaAdminControllerResumoDoFunil>>,
          TError,
          Awaited<ReturnType<typeof auditoriaAdminControllerResumoDoFunil>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditoriaAdminControllerResumoDoFunil<TData = Awaited<ReturnType<typeof auditoriaAdminControllerResumoDoFunil>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerResumoDoFunil>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Quantos rascunhos do wizard web (ainda ativos) estão parados em cada etapa agora
 */

export function useAuditoriaAdminControllerResumoDoFunil<TData = Awaited<ReturnType<typeof auditoriaAdminControllerResumoDoFunil>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerResumoDoFunil>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditoriaAdminControllerResumoDoFunilQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAuditoriaAdminControllerAutoresDoFunilUrl = () => {




  return `/v1/admin/auditoria/funil-discussoes/autores`
}

/**
 * @summary Médicos com pelo menos um rascunho do wizard web — para o filtro por autor
 */
export const auditoriaAdminControllerAutoresDoFunil = async ( options?: Parameters<typeof httpClient>[1]): Promise<ListaDeAutoresDoFunilResponse> => {

  return httpClient<ListaDeAutoresDoFunilResponse>(getAuditoriaAdminControllerAutoresDoFunilUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAuditoriaAdminControllerAutoresDoFunilQueryKey = () => {
    return [
    `/v1/admin/auditoria/funil-discussoes/autores`
    ] as const;
    }


export const getAuditoriaAdminControllerAutoresDoFunilQueryOptions = <TData = Awaited<ReturnType<typeof auditoriaAdminControllerAutoresDoFunil>>, TError = ErroResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerAutoresDoFunil>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditoriaAdminControllerAutoresDoFunilQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditoriaAdminControllerAutoresDoFunil>>> = ({ signal }) => auditoriaAdminControllerAutoresDoFunil({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerAutoresDoFunil>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditoriaAdminControllerAutoresDoFunilQueryResult = NonNullable<Awaited<ReturnType<typeof auditoriaAdminControllerAutoresDoFunil>>>
export type AuditoriaAdminControllerAutoresDoFunilQueryError = ErroResponse


export function useAuditoriaAdminControllerAutoresDoFunil<TData = Awaited<ReturnType<typeof auditoriaAdminControllerAutoresDoFunil>>, TError = ErroResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerAutoresDoFunil>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditoriaAdminControllerAutoresDoFunil>>,
          TError,
          Awaited<ReturnType<typeof auditoriaAdminControllerAutoresDoFunil>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditoriaAdminControllerAutoresDoFunil<TData = Awaited<ReturnType<typeof auditoriaAdminControllerAutoresDoFunil>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerAutoresDoFunil>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditoriaAdminControllerAutoresDoFunil>>,
          TError,
          Awaited<ReturnType<typeof auditoriaAdminControllerAutoresDoFunil>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditoriaAdminControllerAutoresDoFunil<TData = Awaited<ReturnType<typeof auditoriaAdminControllerAutoresDoFunil>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerAutoresDoFunil>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Médicos com pelo menos um rascunho do wizard web — para o filtro por autor
 */

export function useAuditoriaAdminControllerAutoresDoFunil<TData = Awaited<ReturnType<typeof auditoriaAdminControllerAutoresDoFunil>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerAutoresDoFunil>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditoriaAdminControllerAutoresDoFunilQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAuditoriaAdminControllerListarFunilUrl = (params?: AuditoriaAdminControllerListarFunilParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/auditoria/funil-discussoes?${stringifiedParams}` : `/v1/admin/auditoria/funil-discussoes`
}

/**
 * @summary Lista os rascunhos do wizard web (ativos e expirados), com a etapa em que cada um parou
 */
export const auditoriaAdminControllerListarFunil = async (params?: AuditoriaAdminControllerListarFunilParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDoFunilDiscussoesResponse> => {

  return httpClient<PaginaDoFunilDiscussoesResponse>(getAuditoriaAdminControllerListarFunilUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAuditoriaAdminControllerListarFunilQueryKey = (params?: AuditoriaAdminControllerListarFunilParams,) => {
    return [
    `/v1/admin/auditoria/funil-discussoes`, ...(params ? [params] : [])
    ] as const;
    }


export const getAuditoriaAdminControllerListarFunilQueryOptions = <TData = Awaited<ReturnType<typeof auditoriaAdminControllerListarFunil>>, TError = ErroResponse>(params?: AuditoriaAdminControllerListarFunilParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerListarFunil>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditoriaAdminControllerListarFunilQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditoriaAdminControllerListarFunil>>> = ({ signal }) => auditoriaAdminControllerListarFunil(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerListarFunil>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditoriaAdminControllerListarFunilQueryResult = NonNullable<Awaited<ReturnType<typeof auditoriaAdminControllerListarFunil>>>
export type AuditoriaAdminControllerListarFunilQueryError = ErroResponse


export function useAuditoriaAdminControllerListarFunil<TData = Awaited<ReturnType<typeof auditoriaAdminControllerListarFunil>>, TError = ErroResponse>(
 params: undefined |  AuditoriaAdminControllerListarFunilParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerListarFunil>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditoriaAdminControllerListarFunil>>,
          TError,
          Awaited<ReturnType<typeof auditoriaAdminControllerListarFunil>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditoriaAdminControllerListarFunil<TData = Awaited<ReturnType<typeof auditoriaAdminControllerListarFunil>>, TError = ErroResponse>(
 params?: AuditoriaAdminControllerListarFunilParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerListarFunil>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditoriaAdminControllerListarFunil>>,
          TError,
          Awaited<ReturnType<typeof auditoriaAdminControllerListarFunil>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditoriaAdminControllerListarFunil<TData = Awaited<ReturnType<typeof auditoriaAdminControllerListarFunil>>, TError = ErroResponse>(
 params?: AuditoriaAdminControllerListarFunilParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerListarFunil>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os rascunhos do wizard web (ativos e expirados), com a etapa em que cada um parou
 */

export function useAuditoriaAdminControllerListarFunil<TData = Awaited<ReturnType<typeof auditoriaAdminControllerListarFunil>>, TError = ErroResponse>(
 params?: AuditoriaAdminControllerListarFunilParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerListarFunil>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditoriaAdminControllerListarFunilQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAuditoriaAdminControllerExportarFunilCsvUrl = (params?: AuditoriaAdminControllerExportarFunilCsvParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/auditoria/funil-discussoes/exportar.csv?${stringifiedParams}` : `/v1/admin/auditoria/funil-discussoes/exportar.csv`
}

/**
 * Sem filtro nenhum: todos os rascunhos (ativos e expirados), sem data. Com etapa/status/autor/ambiente, MESMO recorte da tela; `desde`/`ate` limitam por `progressoAtualizadoEm` — campo novo, a tela não tem período.
 * @summary Exporta o funil de discussões em CSV
 */
export const auditoriaAdminControllerExportarFunilCsv = async (params?: AuditoriaAdminControllerExportarFunilCsvParams, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getAuditoriaAdminControllerExportarFunilCsvUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAuditoriaAdminControllerExportarFunilCsvQueryKey = (params?: AuditoriaAdminControllerExportarFunilCsvParams,) => {
    return [
    `/v1/admin/auditoria/funil-discussoes/exportar.csv`, ...(params ? [params] : [])
    ] as const;
    }


export const getAuditoriaAdminControllerExportarFunilCsvQueryOptions = <TData = Awaited<ReturnType<typeof auditoriaAdminControllerExportarFunilCsv>>, TError = unknown>(params?: AuditoriaAdminControllerExportarFunilCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerExportarFunilCsv>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditoriaAdminControllerExportarFunilCsvQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditoriaAdminControllerExportarFunilCsv>>> = ({ signal }) => auditoriaAdminControllerExportarFunilCsv(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerExportarFunilCsv>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditoriaAdminControllerExportarFunilCsvQueryResult = NonNullable<Awaited<ReturnType<typeof auditoriaAdminControllerExportarFunilCsv>>>
export type AuditoriaAdminControllerExportarFunilCsvQueryError = unknown


export function useAuditoriaAdminControllerExportarFunilCsv<TData = Awaited<ReturnType<typeof auditoriaAdminControllerExportarFunilCsv>>, TError = unknown>(
 params: undefined |  AuditoriaAdminControllerExportarFunilCsvParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerExportarFunilCsv>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditoriaAdminControllerExportarFunilCsv>>,
          TError,
          Awaited<ReturnType<typeof auditoriaAdminControllerExportarFunilCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditoriaAdminControllerExportarFunilCsv<TData = Awaited<ReturnType<typeof auditoriaAdminControllerExportarFunilCsv>>, TError = unknown>(
 params?: AuditoriaAdminControllerExportarFunilCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerExportarFunilCsv>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditoriaAdminControllerExportarFunilCsv>>,
          TError,
          Awaited<ReturnType<typeof auditoriaAdminControllerExportarFunilCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditoriaAdminControllerExportarFunilCsv<TData = Awaited<ReturnType<typeof auditoriaAdminControllerExportarFunilCsv>>, TError = unknown>(
 params?: AuditoriaAdminControllerExportarFunilCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerExportarFunilCsv>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Exporta o funil de discussões em CSV
 */

export function useAuditoriaAdminControllerExportarFunilCsv<TData = Awaited<ReturnType<typeof auditoriaAdminControllerExportarFunilCsv>>, TError = unknown>(
 params?: AuditoriaAdminControllerExportarFunilCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditoriaAdminControllerExportarFunilCsv>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditoriaAdminControllerExportarFunilCsvQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






